<template>
  <sg-spacing t-xs v-if="$slots.defualt || error">
    <sg-text small lead-tight red class="inline-flex items-center">
      <sg-spacing r-xs>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 16 16"
          fill="currentColor"
          stroke="currentColor"
          class="h-4 w-4"
        >
          <g>
            <circle
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-miterlimit="10"
              cx="8.5"
              cy="8.5"
              r="7"
            />
            <circle data-stroke="none" cx="8.5" cy="12" r="1" stroke="none" />
            <path
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-miterlimit="10"
              d="M8.5 4.5V9"
            />
          </g>
        </svg>
      </sg-spacing>
      {{ error }}
      <slot />
    </sg-text>
  </sg-spacing>
</template>

<script>
export default {
  props: {
    error: {
      type: String,
      default: null,
    },
  },
};
</script>
